<template>
  <div>
    <div
      class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
      style="margin-bottom:0px"
    >
      <h2 class="text-primary black" style="margin-top:0px">{{$t('Change conference')}}</h2>
    </div>

    <div class="md-list md-layout-item md-size-100">
      <li class="md-list-item" style="margin:auto;">
        <a
          class="md-list-item-router md-list-item-container md-button-clean dropdown"
          style="width:100%"
        >
          <div class="md-list-item-content" style="width:100%">
            <drop-down direction="down" style="margin-top:2px; width:100%">
              <div>
                <md-button
                  slot="title"
                  class="md-button md-button-link md-simple dropdown-toggle"
                  data-toggle="dropdown"
                  style="width:100%"
                >
                  <div
                    class="text-gray regular"
                    style="font-size: 14px;  word-break:break-all;width:100%; overflow:hidden"
                  >{{conference.description[language.code].name}}</div>
                </md-button>
                <ul class="dropdown-menu dropdown-with-icons" style="margin-top:16px">
                  <li v-for="conf in conferences" :key="conf.key">
                    <a @click="changeConference(conf);">
                      <span
                        class="regular"
                        style=" font-size:14px; width: 100%;overflow: hidden;"
                      >{{conf.description[language.code].name}}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </drop-down>
          </div>
        </a>
      </li>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      showConferences: false
    };
  },
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current",
      conferences: "conference/all",
      isLoggedIn: "user/isLoggedIn",
      profile: "user/profile"
    })
  },
  methods: {
    async changeConference(conf) {
      await this.$store.dispatch("conference/changeCurrent", conf);
      await this.$store.dispatch("user/refreshProfile");
    }
  }
};
</script>
<style>
.conference-icon {
  width: 60px;
}
.conference-small-icon {
  width: 40px;
}
.noLeftPadding > * {
  padding-left: 0px !important;
}
a:hover {
  color: white !important;
}

@media screen and (max-width: 600px) {
  .conferencesList {
    padding-left: 0px !important;
  }
  .md-list-item {
    width: 100%;
  }
  ul {
    width: 100%;
  }
}
</style>